/**
 * 覆盖翻译平台自动同步的数据，一般用于紧急文案缺失的问题，避免delay
 * 正常情况一定要按标准流程，让产品翻译平台提翻译需求
 *
 * 注意：这只是紧急方案，翻译平台批量新增翻译时，会漏掉这部分
 * 这里的 UI Key 是人为构造的，与翻译平台自动生成的保持一致便可
 * 为便于检索，可以统一以 _AAAA 后缀结尾
 * 闪送B2C exp: 'FoodC_B2C_home_xxx_AAAA': '',
 */
export default {
  'zh-CN': {
    'FoodC_B2C_home_xxx_AAAA': '',
    'FoodC_B2C_home_login_or_register_AAAA': '登录/注册',
    'FoodC_B2C_home_new_deliveries_AAAA': '一种新的更好的交付方式',
    'FoodC_B2C_home_new_deliveries_desc_AAAA': '即时点对点交付：可靠、方便且经济高效',

    'FoodC_B2C_home_recommend_desc1_AAAA': '我们将您的产品送到客户家门口，让您专注于发展业务。我们是您的理想盟友！',
    'FoodC_B2C_home_recommend_desc2_AAAA': '使用这个即时交付工具来激活您自己的销售渠道。与我们分享取货和送货的详细信息，我们将为您指派一名送货合作伙伴，他们将在摩托车或自行车上提供服务',
    'FoodC_B2C_home_recommend_feed_back_AAAA': '',

    'FoodC_B2C_home_how_to_use_title_AAAA': '如何使用闪送？',
    'FoodC_B2C_home_how_to_use_step1_title_AAAA': 'Step 1',
    'FoodC_B2C_home_how_to_use_step1_desc_AAAA': '',
    'FoodC_B2C_home_how_to_use_step2_title_AAAA': 'Step 2',
    'FoodC_B2C_home_how_to_use_step2_desc_AAAA': '',
    'FoodC_B2C_home_how_to_use_step3_title_AAAA': 'Step 3',
    'FoodC_B2C_home_how_to_use_step3_desc_AAAA': '',

    'FoodC_B2C_home_recommend_why_title_AAAA': '',
    'FoodC_B2C_home_recommend_why_Convenience_title_AAAA': '',
    'FoodC_B2C_home_recommend_why_Convenience_desc_AAAA': '',
    'FoodC_B2C_home_recommend_why_Economical_title_AAAA': '',
    'FoodC_B2C_home_recommend_why_Economical_desc_AAAA': '',
    'FoodC_B2C_home_recommend_why_Efficient_title_AAAA': '',
    'FoodC_B2C_home_recommend_why_Efficient_desc_AAAA': '',
    'FoodC_B2C_home_recommend_why_Safe_title_AAAA': '',
    'FoodC_B2C_home_recommend_why_Safe_desc_AAAA': '',

    'FoodC_B2C_home_about_us_title_AAAA': '',
    'FoodC_B2C_home_about_us_screen_title_AAAA': '',
    'FoodC_B2C_home_about_us_screen_desc_AAAA': '',
    'FoodC_B2C_home_about_us_delivery_title_AAAA': '',
    'FoodC_B2C_home_about_us_delivery_desc_AAAA': '',
    'FoodC_B2C_home_about_us_fastest_title_AAAA': '',
    'FoodC_B2C_home_about_us_fastest_desc_AAAA': '',
    'FoodC_B2C_home_about_us_loan_title_AAAA': '',
    'FoodC_B2C_home_about_us_loan_desc_AAAA': '',
    'FoodC_B2C_home_about_us_task_title_AAAA': '',
    'FoodC_B2C_home_about_us_task_desc_AAAA': '',
    'FoodC_B2C_home_about_us_help_title_AAAA': '',
    'FoodC_B2C_home_about_us_help_desc_AAAA': '',

    'FoodC_B2C_home_new_rider_title_AAAA': '',
    'FoodC_B2C_home_new_rider_desc_AAAA': '',
    'FoodC_B2C_home_new_rider_btn_AAAA': '',

    'FoodC_B2C_home_footer_city_title_AAAA': '',
    'FoodC_B2C_home_footer_city_Puebla_AAAA': '',
    'FoodC_B2C_home_footer_partner_title_AAAA': '',
    'FoodC_B2C_home_footer_partner_rider_AAAA': '',
    'FoodC_B2C_home_footer_contact_title_AAAA': '',
    'FoodC_B2C_home_footer_contact_FAQ_AAAA': '',
    'FoodC_B2C_home_footer_contact_more_AAAA': '',
  },
  'en-US': {
    'FoodC_B2C_home_login_or_register_AAAA': 'Log in/Register',
    'FoodC_B2C_home_new_deliveries_AAAA': 'A new way to optimize your deliveries',
    'FoodC_B2C_home_new_deliveries_desc_AAAA': 'Immediate point-to-point deliveries: reliable, convenient, and cost-effective',

    'FoodC_B2C_home_recommend_desc1_AAAA': "We deliver your products to your customers' doorstep so you can focus on growing your business. We are your ideal ally!",
    'FoodC_B2C_home_recommend_desc2_AAAA': "Enhace your own sales channels using this instant delivery tool. Share with us the pickup and delivery details and we'll assign you a delivery partner who will perform the service on their motorcycle or bicycle",
    'FoodC_B2C_home_recommend_feed_back_AAAA': `Do you have questions? Leave your information <a href="https://page.didiglobal.com/global/silver-bullet-pre/default-online/pre/entrega-business-mx"
    >here</a>,<br> and one of our agents will contact you or send us an email at entregabusiness@didiglobal.com`,

    'FoodC_B2C_home_how_to_use_title_AAAA': 'How does DiDi Entrega Business work?',
    'FoodC_B2C_home_how_to_use_step1_title_AAAA': 'Step 1',
    'FoodC_B2C_home_how_to_use_step1_desc_AAAA': 'Log In or create an account',
    'FoodC_B2C_home_how_to_use_step2_title_AAAA': 'Step 2',
    'FoodC_B2C_home_how_to_use_step2_desc_AAAA': 'Enter pickup and delivery information. You can choose from your history for added efficiency!',
    'FoodC_B2C_home_how_to_use_step3_title_AAAA': 'Step 3',
    'FoodC_B2C_home_how_to_use_step3_desc_AAAA': 'Make payment for the delivery service and wait for one of our courier partners ',

    'FoodC_B2C_home_recommend_why_title_AAAA': 'Why Choose DiDi Entrega Business?',
    'FoodC_B2C_home_recommend_why_Convenience_title_AAAA': 'Convenience',
    'FoodC_B2C_home_recommend_why_Convenience_desc_AAAA': 'Simplify your deliveries using your favorite device with efficient routes generated by our system',
    'FoodC_B2C_home_recommend_why_Economical_title_AAAA': 'Economical',
    'FoodC_B2C_home_recommend_why_Economical_desc_AAAA': 'Send your products starting from $27 MXN and choose the payment method you prefer',
    'FoodC_B2C_home_recommend_why_Efficient_title_AAAA': 'Efficient',
    'FoodC_B2C_home_recommend_why_Efficient_desc_AAAA': 'Fulfill all home delivery requests while keeping your operation running smoothly',
    'FoodC_B2C_home_recommend_why_Safe_title_AAAA': 'Safe',
    'FoodC_B2C_home_recommend_why_Safe_desc_AAAA': 'Ensure the peace of mind for your deliveries with security codes and real-time tracking',

    'FoodC_B2C_home_about_us_title_AAAA': 'Get to know more about our service!',
    'FoodC_B2C_home_about_us_screen_title_AAAA': 'Control panel',
    'FoodC_B2C_home_about_us_screen_desc_AAAA': 'You will have a control panel to keep track of your orders',
    'FoodC_B2C_home_about_us_delivery_title_AAAA': 'Couriers',
    'FoodC_B2C_home_about_us_delivery_desc_AAAA': 'There will always be a courier ready to deliver your package',
    'FoodC_B2C_home_about_us_fastest_title_AAAA': 'Efficient deliveries',
    'FoodC_B2C_home_about_us_fastest_desc_AAAA': 'Request up to 10 simultaneous deliveries, reaching more customers in less time',
    'FoodC_B2C_home_about_us_loan_title_AAAA': 'Payment options',
    'FoodC_B2C_home_about_us_loan_desc_AAAA': 'Choose between cash, credit card, or debit card to tailor your payments to your needs',
    'FoodC_B2C_home_about_us_task_title_AAAA': 'Security PIN',
    'FoodC_B2C_home_about_us_task_desc_AAAA': 'Your end customer will receive a PIN and will need to share it to accept the package',
    'FoodC_B2C_home_about_us_help_title_AAAA': 'Live chat support',
    'FoodC_B2C_home_about_us_help_desc_AAAA': 'Get personalized assistance from request to delivery, ensuring a smooth and reliable experience',

    'FoodC_B2C_home_new_rider_title_AAAA': 'Do you have a motorbike or bicycle?<br>Become a courier!',
    'FoodC_B2C_home_new_rider_desc_AAAA': 'Start earning with DiDi Entrega Business or DiDi Food. The best part is you choose when and where to make deliveries!',
    'FoodC_B2C_home_new_rider_btn_AAAA': 'Register now',

    'FoodC_B2C_home_footer_city_title_AAAA': 'Cities in which we have presence',
    'FoodC_B2C_home_footer_city_Puebla_AAAA': 'Puebla',
    'FoodC_B2C_home_footer_partner_title_AAAA': 'Partner with us',
    'FoodC_B2C_home_footer_partner_rider_AAAA': 'Become a courier',
    'FoodC_B2C_home_footer_contact_title_AAAA': '',
    'FoodC_B2C_home_footer_contact_FAQ_AAAA': 'FAQs',
    'FoodC_B2C_home_footer_contact_more_AAAA': 'If you want to learn more about our service, please contact our support team by calling  800 801 6888 and dialing first number 3 and then 2.',
  },
  'es-MX': {
    'FoodC_B2C_home_login_or_register_AAAA': 'Inicia sesión/ Regístrate',
    'FoodC_B2C_home_new_deliveries_AAAA': 'Una nueva forma de optimizar tus envíos',
    'FoodC_B2C_home_new_deliveries_desc_AAAA': 'Envíos inmediatos de punto a punto: confiables, convenientes y económicos',

    'FoodC_B2C_home_recommend_desc1_AAAA': 'Llevamos tus productos hasta la puerta de tus clientes para que puedas enfocarte en el crecimiento de tu negocio ¡Somos tu aliado ideal!',
    'FoodC_B2C_home_recommend_desc2_AAAA': 'Empodera tus canales de venta utilizando esta herramienta de envíos instantáneos.  Compártenos los datos de recolección y entrega y te asignaremos un socio repartidor que efectuará el servicio en su moto o bicicleta',
    'FoodC_B2C_home_recommend_feed_back_AAAA': `¿Tienes dudas? Deja tus datos <a href="https://page.didiglobal.com/global/silver-bullet-pre/default-online/pre/entrega-business-mx">aquí</a>,<br> y uno de nuestros agentes te contactará o envíanos un mail a entregabusiness@didiglobal.com`,

    'FoodC_B2C_home_how_to_use_title_AAAA': '¿Cómo funciona DiDi Entrega Business?',
    'FoodC_B2C_home_how_to_use_step1_title_AAAA': 'Paso 1',
    'FoodC_B2C_home_how_to_use_step1_desc_AAAA': 'Regístrate o inicia sesión',
    'FoodC_B2C_home_how_to_use_step2_title_AAAA': 'Paso 2',
    'FoodC_B2C_home_how_to_use_step2_desc_AAAA': 'Ingresa datos de recolección y entrega ¡Puedes elegir entre tu historial para mayor agilidad!',
    'FoodC_B2C_home_how_to_use_step3_title_AAAA': 'Paso 3',
    'FoodC_B2C_home_how_to_use_step3_desc_AAAA': 'Efectúa el pago del envío y espera a uno de nuestros socios repartidores',

    'FoodC_B2C_home_recommend_why_title_AAAA': '¿Por qué elegir DiDi Entrega Business?',
    'FoodC_B2C_home_recommend_why_Convenience_title_AAAA': 'Conveniente',
    'FoodC_B2C_home_recommend_why_Convenience_desc_AAAA': 'Simplifica tus entregas usando tu dispositivo favorito con rutas  eficientes hechas por nuestro sistema',
    'FoodC_B2C_home_recommend_why_Economical_title_AAAA': 'Económico',
    'FoodC_B2C_home_recommend_why_Economical_desc_AAAA': 'Envía tus productos desde $27 m.n y elige el método de pago que prefieras',
    'FoodC_B2C_home_recommend_why_Efficient_title_AAAA': 'Eficiente',
    'FoodC_B2C_home_recommend_why_Efficient_desc_AAAA': 'Cumple con todas las solicitudes de entrega a domicilio mientras mantienes tu operación en marcha',
    'FoodC_B2C_home_recommend_why_Safe_title_AAAA': 'Seguro',
    'FoodC_B2C_home_recommend_why_Safe_desc_AAAA': 'Asegura la tranquilidad de tus entregas con códigos de seguridad y seguimiento en tiempo real',

    'FoodC_B2C_home_about_us_title_AAAA': '¡Conoce más acerca de nosotros!',
    'FoodC_B2C_home_about_us_screen_title_AAAA': 'Panel de control',
    'FoodC_B2C_home_about_us_screen_desc_AAAA': 'Tendrás un panel de control para llevar registro de tus pedidos',
    'FoodC_B2C_home_about_us_delivery_title_AAAA': 'Repartidores',
    'FoodC_B2C_home_about_us_delivery_desc_AAAA': 'Siempre habrá un repartidor listo para entregar tu paquete',
    'FoodC_B2C_home_about_us_fastest_title_AAAA': 'Envíos eficientes',
    'FoodC_B2C_home_about_us_fastest_desc_AAAA': 'Solicita hasta 10 entregas de manera simultánea, llegando a más clientes en menos tiempo',
    'FoodC_B2C_home_about_us_loan_title_AAAA': 'Formas de pago',
    'FoodC_B2C_home_about_us_loan_desc_AAAA': 'Elige entre efectivo, tarjeta de crédito o débito para adaptar tus pagos a tus necesidades',
    'FoodC_B2C_home_about_us_task_title_AAAA': 'Código de seguridad',
    'FoodC_B2C_home_about_us_task_desc_AAAA': 'Tu cliente final recibirá un PIN y tendrá que compartirlo para aceptar el paquete',
    'FoodC_B2C_home_about_us_help_title_AAAA': 'Chat en vivo',
    'FoodC_B2C_home_about_us_help_desc_AAAA': 'Obtén asistencia personalizada, desde la solicitud hasta la entrega, asegurando una experiencia fluida y confiable',

    'FoodC_B2C_home_new_rider_title_AAAA': '¿Tienes una moto o bicicleta?<br>¡Conviértete en repartidor!',
    'FoodC_B2C_home_new_rider_desc_AAAA': 'Empieza a generar ganancias con DiDi Entrega Business o con DiDi Food ¡Lo mejor es que tú eliges cuándo y dónde repartir!',
    'FoodC_B2C_home_new_rider_btn_AAAA': 'Registrarme',

    'FoodC_B2C_home_footer_city_title_AAAA': 'Ciudades en las que tenemos presencia',
    'FoodC_B2C_home_footer_city_Puebla_AAAA': 'Puebla',
    'FoodC_B2C_home_footer_partner_title_AAAA': '',
    'FoodC_B2C_home_footer_partner_rider_AAAA': 'Conviértete en repartidor',
    'FoodC_B2C_home_footer_contact_title_AAAA': '',
    'FoodC_B2C_home_footer_contact_FAQ_AAAA': 'Preguntas frecuentes',
    'FoodC_B2C_home_footer_contact_more_AAAA': 'Para más información llama al 800 801 6888 seleccionando primero la opción  3 y después la opción 2.',
  },
  'pt-BR': {
  },
  'es-419': {
   },
};
